import { render } from "./BaseEditDialogTranslations.vue?vue&type=template&id=5f4bbbea"
import script from "./BaseEditDialogTranslations.vue?vue&type=script&lang=js"
export * from "./BaseEditDialogTranslations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__